import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface WinCheckUser {
  id: string;
  telegramId: string;
  username: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  displayName: string;
  balance: number;
}

export interface WinCheckGameListItem {
  id: string;
  historyId: string;
  roomId: string;
  betAmount: number;
  startedAt: string;
  finishedAt: string;
  durationMs: number;
  callIndex: number;
  winnerCallIndex: number | null;
  prizePool: number;
  netPrizePool: number;
  playersCount: number;
  myCartelaNumbers: number[];
  myWonCartelas: number[];
  myTotalBet: number;
  myTotalWon: number;
  iAmWinner: boolean;
}

export interface WinCheckGrid {
  B: (number | null)[];
  I: (number | null)[];
  N: (number | null)[];
  G: (number | null)[];
  O: (number | null)[];
}

export interface WinCheckPatterns {
  horizontal: boolean;
  vertical: boolean;
  diagonal: boolean;
  singleCorner: boolean;
  singleMiddle: boolean;
  middleCross: boolean;
  full: boolean;
}

export interface WinCheckCartela {
  cartelaNumber: number;
  grid: WinCheckGrid | null;
}

export interface WinCheckMyWinner {
  userId: string;
  telegramId: string;
  displayName: string;
  cartelaNumber: number;
  pattern: string;
  patternName: string;
  callIndex: number;
  prizeAmount: number;
  balanceBefore: number;
  balanceAfter: number;
  grid: WinCheckGrid | null;
  winningCells: Array<{ letter: string; row: number; value: number | null }>;
}

export interface WinCheckGameDetail {
  game: {
    id: string;
    historyId: string;
    roomId: string;
    betAmount: number;
    commissionPercent: number;
    startedAt: string;
    finishedAt: string;
    durationMs: number;
    playersCount: number;
    totalCartelasSold: number;
    prizePool: number;
    netPrizePool: number;
    platformRevenue: number;
    totalPrizeDistributed: number;
    sequence: number[];
    calledNumbers: number[];
    callIndex: number;
    winnerCallIndex: number | null;
    remainingNumbers: number[];
    patterns: WinCheckPatterns;
    patternsRequiredToWin: number;
  };
  me: {
    userId: string;
    telegramId: string;
    displayName: string;
    cartelaNumbers: number[];
    wonCartelas: number[];
    lockedCartelas: number[];
    balanceBefore: number;
    balanceAfter: number;
    totalBet: number;
    totalWon: number;
  };
  cartelas: WinCheckCartela[];
  myWinners: WinCheckMyWinner[];
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

class UserWinCheckService {
  async findUser(q: string): Promise<{
    user: WinCheckUser | null;
    games: WinCheckGameListItem[];
  }> {
    const res = await apiClient.get<
      ApiEnvelope<{ user: WinCheckUser | null; games: WinCheckGameListItem[] }>
    >(API_ENDPOINTS.USER_WIN_CHECK.FIND_USER, { params: { q } });
    return res.data.data;
  }

  async getUserGame(
    telegramId: string,
    gameId: string
  ): Promise<WinCheckGameDetail> {
    const res = await apiClient.get<ApiEnvelope<WinCheckGameDetail>>(
      API_ENDPOINTS.USER_WIN_CHECK.USER_GAME(telegramId, gameId)
    );
    return res.data.data;
  }
}

const userWinCheckService = new UserWinCheckService();
export default userWinCheckService;